import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/DataList/data-list';
export var DataListCheck = function DataListCheck(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$onChange = _a.onChange,
      _onChange = _a$onChange === void 0 ? function (checked, event) {} : _a$onChange,
      _a$isValid = _a.isValid,
      isValid = _a$isValid === void 0 ? true : _a$isValid,
      _a$isDisabled = _a.isDisabled,
      isDisabled = _a$isDisabled === void 0 ? false : _a$isDisabled,
      _a$isChecked = _a.isChecked,
      isChecked = _a$isChecked === void 0 ? null : _a$isChecked,
      _a$checked = _a.checked,
      checked = _a$checked === void 0 ? null : _a$checked,
      props = __rest(_a, ["className", "onChange", "isValid", "isDisabled", "isChecked", "checked"]);

  return React.createElement("div", {
    className: css(styles.dataListItemControl, className)
  }, React.createElement("div", {
    className: css('pf-c-data-list__check')
  }, React.createElement("input", Object.assign({}, props, {
    type: "checkbox",
    onChange: function onChange(event) {
      return _onChange(event.currentTarget.checked, event);
    },
    "aria-invalid": !isValid,
    disabled: isDisabled,
    checked: isChecked || checked
  }))));
};